// session id key which is stored in localstorage
export var SESSION_ID = 'RSID';
export var RIO_CONFIG = 'rioConfig';
export var APP_ID = 'appId';

// events queue key which is stored in local storage
export var EVENTS_QUEUE = 'REQ';
export var HTTPS_PREFIX = 'https://';
export var SEND_EVENT_LOGGING_KEY = '[R2WC] sendEvent';
export var INIT_CLIENT_LOGGING_KEY = '[R2WC] initClient';
export var GET_HOST_NAMES_LOGGING_KEY = '[R2WC] getHostNames';
export var RETRIES = 3;
export var RETRY_INTERVAL = 2000;

// View Properties
export var LS_VIEW = 'r2wc_view';
export var LS_VIEW_PREVIOUS = 'r2wc_view_previous';
export var LS_VIEW_PREVIOUS_V1 = 'rsw_view_previous_cache';
export var UNDEFINED = 'undefined';
export var NULL = 'null';
export var EVENT_REGISTERED_KEY = 'Event registered';

// keys which will be saved in localstorage which corresponds to hostnames
export var HOSTNAME = /*#__PURE__*/function (HOSTNAME) {
  HOSTNAME["PRIMARY_HOST_NAME"] = "RPHN";
  HOSTNAME["SECONDARY_HOST_NAME"] = "RSHN";
  return HOSTNAME;
}({});
export var EnrichData = /*#__PURE__*/function (EnrichData) {
  EnrichData["CVID"] = "CVID";
  EnrichData["CSID"] = "CSID";
  EnrichData["ID_TOKEN"] = "id_token";
  EnrichData["ACCESS_TOKEN"] = "access_token";
  EnrichData["EXPERIMENT"] = "exp";
  EnrichData["URL"] = "url";
  EnrichData["REFERRAL_URL"] = "referral_url";
  EnrichData["QUERY_STRING"] = "query_string";
  EnrichData["VIEW_PROPERTIES"] = "view_properties";
  return EnrichData;
}({});
export var Severity = /*#__PURE__*/function (Severity) {
  Severity["CRITICAL"] = "CRITICAL";
  Severity["ERROR"] = "ERROR";
  Severity["WARNING"] = "WARNING";
  Severity["INFO"] = "INFO";
  Severity["DEBUG"] = "DEBUG";
  return Severity;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/types/index.js
// module id = 144
// module chunks = 11